<template>
  <div class="price-cell">
    <v-text-field
      v-if="isEditable"
      v-model="raw"
      outlined
      dense
      hide-details
      rounded
      prefix="$"
      class="mx-6"
      inputmode="decimal"
      type="text"
      style="margin:auto;"
      @focus="onFocus"
      @blur="onBlur"
      @input="onInput"
    />
    <span v-else style="margin:auto;font-weight:600;">
      {{ currency(value) }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'PriceCell',
  props: {
    editMode: { type: String, required: true },
    columnMode: { type: String, required: true },
    value: { type: [String, Number], required: true }
  },
  data() {
    return {
      raw: '',        // lo que el usuario ve/edita tal cual
      isFocused: false
    }
  },
  computed: {
    isEditable() {
      return this.editMode === this.columnMode
    }
  },
  watch: {
    // sincroniza desde el padre solo cuando NO estás editando activamente
    value: {
      immediate: true,
      handler(val) {
        if (!this.isFocused) {
          this.raw = this.displayValue(val)
        }
      }
    },
    // al entrar en modo editable, precarga el valor actual
    isEditable(newVal) {
      if (newVal) this.raw = this.displayValue(this.value)
    }
  },
  methods: {
    // El precio sin IVA se guarda con más decimales; en pantalla se muestra a 2.
    displayValue(val) {
      if (val === null || val === undefined || val === '') return ''
      const n = Number(val)
      return isNaN(n) ? val.toString() : String(Math.round(n * 100) / 100)
    },
    onFocus() { this.isFocused = true },
    onBlur() {
      this.isFocused = false
      // Normaliza y emite un valor numérico definitivo si es válido
      const n = parseFloat((this.raw || '').replace(',', '.'))
      if (!isNaN(n)) this.$emit('change', n)   // opcional: evento "final"
    },
    onInput(val) {
      this.raw = val
      // Mientras escribe, emite la cadena cruda para que el padre la use si quiere
      this.$emit('input', val)
    },
    currency(v) {
      const n = parseFloat(v || 0)
      return (isNaN(n) ? 0 : n).toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN'
      })
    }
  }
}
</script>

<style scoped>
.price-cell {
  width:100%;
  height:100%;
  display:flex;
  align-items:center;
  justify-content:center;
  text-align:center;
}
</style>
